import { render } from "./kindPart.vue?vue&type=template&id=7c3b6ff7&scoped=true"
import script from "./kindPart.vue?vue&type=script&lang=js"
export * from "./kindPart.vue?vue&type=script&lang=js"

import "./kindPart.vue?vue&type=style&index=0&id=7c3b6ff7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3b6ff7"]])

export default __exports__